document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product-tabs').forEach(function (wrapper) {
    var buttons = wrapper.querySelectorAll('.product-tabs__btn');
    var panels = wrapper.querySelectorAll('.product-tabs__panel');

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var targetId = btn.getAttribute('data-tab-target');

        buttons.forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-selected', 'false');
        });
        panels.forEach(function (p) {
          p.classList.remove('is-active');
        });

        btn.classList.add('is-active');
        btn.setAttribute('aria-selected', 'true');
        wrapper.querySelector('#' + targetId).classList.add('is-active');
      });
    });
  });
});